module.exports = __webpack_public_path__ + "static/media/s1-top-slogan.b4f77602.png";